module.exports = __webpack_public_path__ + "img/development.faaa9982.png";